// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"popOverMenu__gradient-bg5__fhFP1","popOverMenu":"popOverMenu__popOverMenu__AaSGA","ellipsis":"popOverMenu__ellipsis__wCbsM"};